// extracted by mini-css-extract-plugin
export default {"sideDrawer":"SideDrawer_sideDrawer__JTEX6"};